<template>
  <ValidationProvider
    v-slot="{ errors, classes }"
    :rules="rules"
    :mode="custom"
  >
    <v-select
      v-model="dropdownValue"
      v-bind="config"
      class="form-input"
      :class="[classes, { 'non-searchable': !searchable }]"
      :disabled="disabled"
      :searchable="searchable"
      :clearable="clearable"
      v-on="$listeners"
    >
      <template
        v-if="searchable"
        slot="search"
        slot-scope="search"
      >
        <slot
          name="input"
          v-bind="{prefix, numbersOnly, search}"
        >
          <input
            v-prefix="prefix"
            v-numbers-only="numbersOnly"
            class="form-control vs__search--custom m-b-0"
            :class="{ closed: !search.attributes['aria-expanded'] }"
            v-bind="search.attributes"
            v-on="search.events"
          >
        </slot>
      </template>

      <slot name="no-options">
        {{ noOptionsText }}
      </slot>

      <template v-slot:option="option">
        <slot
          :option="option"
          name="option-data"
        />
      </template>

      <template v-slot:selected-option="option">
        <slot
          :option="option"
          name="selected-option-data"
        />
      </template>
    </v-select>
  </ValidationProvider>
</template>

<script>
import messages from './locales';
import sharedMessages from '@/core/locales';

export default {
  name: 'SearchableDropdown',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Object],
      default: null
    },
    config: {
      type: Object,
      default() {
        return {
          placeholder: this.$i18n.t('DROPDOWN_PH'),
          options: []
        };
      },
      required: true
    },
    noOptionsText: {
      type: String,
      default: 'No options'
    },
    rules: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: false
    },
    prefix: {
      type: String,
      default: ''
    },
    numbersOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dropdownValue: {
      get() {
        return this.value;
      },
      set(newDropdownValue) {
        if (this.searchable) {
          this.$emit('input', newDropdownValue);
        }
        this.$emit('change', newDropdownValue);
      }
    }
  },
  methods: {
    custom() {
      return { on: ['search:blur', 'input'] };
    }
  },
  i18n: {
    locale: 'en',
    messages,
    sharedMessages
  }
};
</script>

<style lang="scss" scoped>
.form-input {

  &.invalid {
    border: 1px solid $form-error-red;

    &.vs--open {
      border: none;
    }
    &.touched input.form-control, &.untouched input.form-control {
      border-bottom: none; // prevents double bottom border
    }
  }
}
</style>
